import React from 'react';
import { Button } from '@Sage/hoi-poi-ui';

import EmailTemplatesEmpty from 'components/SvgIcons/emptyScreen/EmailTemplatesEmpty';
import { getLiteral } from 'utils/getLiteral';

import { MARKETING_TEMPLATES_PATHS } from '../marketingTemplatesPaths';

/**
 * Props factory for `TemplatesEmptyView` / `CustomEmptyView` (marketing templates library empty).
 *
 * @param {import('react-router-dom').NavigateFunction} navigate
 * @param {{ showCreateCta?: boolean }} [options]
 * @returns {() => object}
 */
export function createMarketingTemplatesLibraryEmptyViewProps(
    navigate,
    { showCreateCta = true } = {},
) {
    return () => ({
        icon: <EmailTemplatesEmpty />,
        iconType: 'image',
        title: getLiteral('label_marketing_campaigns_templates_empty'),
        subtitle: getLiteral('label_marketing_campaigns_templates_empty_desc'),
        ...(showCreateCta
            ? {
                  others: {
                      callsToAction: [
                          <Button
                              key="create-first"
                              type="secondary"
                              onClick={() => navigate(MARKETING_TEMPLATES_PATHS.NEW_SELECTOR)}
                          >
                              {getLiteral('label_marketing_campaigns_templates_create_first')}
                          </Button>,
                      ],
                  },
              }
            : {}),
    });
}
